module.exports = __webpack_public_path__ + "assets/img/main-type-5.57f7430b.svg";